/** 登录 / 注册 / 验证邮箱 / 找回与重设密码，以及认证页共用的左侧舞台与页脚。 */
const messages = {
  'layout.home': '返回首页',
  'layout.headline': '一个 API Key 接入 Seedance 2.0，一个任务只结算一次',
  'layout.footnote': '{brand} {site} · 按 {currency} 结算 · 额度在线下付款后由运营发放',
  'layout.docs': 'API 文档',
  'layout.models': '模型与价格',

  'v.email': '请输入有效的邮箱地址',
  'v.passwordRequired': '请输入密码',
  'v.passwordMin': '密码至少 10 位',
  'v.passwordMax': '密码最多 128 位',
  'v.confirmMismatch': '两次输入的密码不一致',
  'v.referral': '推荐码为 6 位字母或数字，请检查后重新输入，或留空',
  'v.acceptTerms': '请阅读并同意服务条款与隐私政策',
  'human.failed': '人机验证没有加载成功。请关闭广告拦截等浏览器插件，或切换网络 / 代理节点后重试。',
  'human.retry': '重试',
  'human.powFailed': '安全验证没有完成，请重试。',
  'v.code': '请输入 6 位数字验证码',

  'field.email': '邮箱',
  'field.password': '密码',
  'field.referral': '推荐码（选填）',
  'field.code': '验证码',
  'code.send': '发送验证码',
  'code.resendIn': '{s} 秒后重新发送',
  'code.sent': '验证码已发送，请查收邮件',
  'code.sendFailed': '发送失败',
  'code.hint': '6 位验证码，10 分钟内有效。没有收到？检查垃圾邮件，或稍后重新发送。',

  'login.title': '登录',
  'login.descRedirect': '请先登录，登录后回到刚才的页面。',
  'login.desc': '登录控制台，管理 API Key、素材与任务。',
  'login.failed': '登录失败',
  'login.submit': '登录',
  'login.forgot': '忘记密码',
  'login.noAccount': '还没有账号？<link>注册</link>',
  'login.tab.password': '密码登录',
  'login.tab.code': '验证码登录',
  'login.passwordHint': '还没设置过密码？请用验证码登录，登录后可在账号设置中设置密码。',
  'login.codeSubmit': '登录',

  'register.title': '创建账号',
  'register.desc': '用邮箱验证码注册，无需设置密码；注册后可在账号设置中设置登录密码。',
  'register.failed': '注册失败',
  'register.referralHint': '朋友分享的 6 位推荐码；注册后不可更改。',
  'register.submit': '注册并登录',
  'register.accept': '我已阅读并同意<terms>《服务条款》</terms>和<privacy>《隐私政策》</privacy>',
  'register.hasAccount': '已有账号？<link>登录</link>',


  'forgot.title': '找回密码',
  'forgot.desc': '输入注册邮箱，我们会发送一个 6 位验证码用于重设密码。',
  'forgot.failed': '发送失败',
  'forgot.submit': '发送验证码',
  'forgot.back': '返回登录',
  'forgot.toast.sent': '如果该邮箱已注册，你会收到一封含 6 位验证码的邮件',

  'reset.title': '重设密码',
  'reset.desc': '重设后，所有设备上的登录都会退出。',
  'reset.failed': '重设失败',
  'reset.codeLabel': '邮件中的验证码',
  'reset.newPassword': '新密码',
  'reset.newPasswordHint': '至少 10 位。',
  'reset.confirm': '确认新密码',
  'reset.submit': '重设密码',
  'reset.resend': '没有收到验证码？重新发送',
  'reset.toast.done': '密码已重设，请用新密码登录',

  'login.mfa.title': '两步验证',
  'login.mfa.desc': '请输入验证器 App 上显示的 6 位动态码。',
  'login.mfa.code': '动态码',
  'login.mfa.submit': '验证并登录',
  'login.mfa.back': '返回',
  'login.mfa.lost': '验证器和恢复码都丢了？请联系客服，核实身份后为你重置两步验证。',
  'login.mfa.expired': '验证已过期或失败次数过多，请重新输入密码。',
  'login.mfa.useRecovery': '使用恢复码',
  'login.mfa.useCode': '改用动态码',
  'login.mfa.recovery': '恢复码',
  'login.mfa.recoveryHint': '开启两步验证时保存的 10 位恢复码之一，每个只能用一次。',
  'login.mfa.expiredCode': '验证已过期或失败次数过多，请重新获取邮箱验证码。',
};

export default messages;
